export const SNAPSHOT_PENDING_ERROR_CODE = "SNAPSHOT_PENDING";
export const SNAPSHOT_MISSING_ERROR_CODE = "ECSN-54123";

export { SnapshotProcessing } from "./SnapshotProcessing";
export { SnapshotMissingError } from "./SnapshotMissingError";
export {
  useSnapshotPendingPolling,
  SNAPSHOT_PENDING_POLL_MS,
  SNAPSHOT_PENDING_TIMEOUT_MS,
} from "./useSnapshotPendingPolling";
